/**
 * anchor-headings.js
 * Silently injects slug-based `id` attributes onto every h1, h2, and h3
 * inside <main>. Allows direct URL anchoring: page-url#heading-slug
 *
 * - Only targets content inside <main> (excludes header, footer, nav)
 * - Skips headings that already have an id
 * - Deduplicates slugs with a -2, -3 suffix
 * - Runs on DOMContentLoaded; no visible icon or UI change
 */
(function () {
  'use strict';

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')        // spaces → hyphens
      .replace(/[^\w\-]+/g, '')    // strip non-word chars
      .replace(/\-\-+/g, '-')      // collapse multiple hyphens
      .replace(/^-+|-+$/g, '');    // trim leading/trailing hyphens
  }

  function addAnchors() {
    var usedIds = {};

    document
      .querySelectorAll('main h1, main h2, main h3')
      .forEach(function (heading) {
        // Skip if already has an id
        if (heading.id) return;

        // Use text content only (strip any HTML inside the heading)
        var text = heading.textContent.trim();
        if (!text) return;

        var slug = slugify(text);
        if (!slug) return;

        // Deduplicate: if slug already used, append -2, -3, etc.
        if (usedIds[slug] !== undefined) {
          usedIds[slug] += 1;
          slug = slug + '-' + usedIds[slug];
        } else {
          usedIds[slug] = 1;
        }

        heading.id = slug;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addAnchors);
  } else {
    addAnchors();
  }
})();
